import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import shubhamD from '../../../assets/images/team/3.png';
import mansi from '../../../assets/images/team/4.png';
import vishnu from '../../../assets/images/team/5.png';
import sunny from '../../../assets/images/team/6.png';
import sanket from '../../../assets/images/team/7.png';
import shubhamN from '../../../assets/images/team/8.png';
const teamMembers = [
    { name: 'Shubham Donankar', role: 'Sales Executive', img: shubhamD },
    { name: 'Sanket Kolapwar', role: 'Sr. Sales Executive', img: sanket },
    { name: 'Shubham Naik', role: 'Marketing and Product Manager', img: shubhamN },
    { name: 'Mansi Parmar', role: 'Accounts Incharge', img: mansi},
    { name: 'Vishnu Suryavanshi', role: 'Warehouse Incharge', img: vishnu },
    { name: 'Sunny Nirwane', role: 'Transport Incharge', img: sunny }
];

const Team = () => {
    return (
       
        <section className="section py-5 hero-section" id="team">
            <Container>
                <Row className="text-center g-1">
                    <h2 className="fw-bold mb-4" style={{ color: "rgb(52, 81, 159)" }}>Meet Our Team</h2>
                    {teamMembers.map((member, index) => (
                        <Col key={index} md={4} sm={6} className="mb-2">
                            <div className="p-2 text-center">
                            
                                 <img 
                                    src={member.img} 
                                    alt={member.name} 
                                    style={{ width: '180px', height: '180px', borderRadius: '50%', objectFit: 'contain', margin: 'auto' }}
                                />
                                <h5 className="mt-2 fw-bold" style={{ color: "rgb(52, 81, 159)" }}>{member.name}</h5>
                                <p className="mt-2 fw-bold" style={{ color: "rgb(52, 81, 159)" }}>({member.role})</p>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default Team;
